import get from 'lodash/get';
import lodashPick from 'lodash/pick';
import join from 'lodash/join';
import moment from 'moment';
import compact from 'lodash/compact';

import getUserDescription from './getUserDescription';
import { PROFILE_FIELDS } from '../constants/strings';

const getPreparedProfileData = (profile, genderTypesList, formatMessage) => {
  const { dob, gender, employeeProfile } = profile;

  const ageString = dob && moment(dob).format('M/D/YYYY');
  const genderString = getUserDescription(
    { gender },
    genderTypesList,
    formatMessage,
  );

  const shortDescription = getUserDescription(
    profile,
    genderTypesList,
    formatMessage,
  );

  const advancedDob = join(compact([genderString, ageString]), ', ');

  const initData = {
    allergies: null,
    medicine: null,
    healthGoals: null,
    mrns: [],
  };

  const payload = profile.primaryPatientProfile
    ? lodashPick(profile.primaryPatientProfile, Object.keys(initData))
    : initData;

  const { allergies, medicine, healthGoals, mrns = [] } = payload;

  const detailsData = {
    [formatMessage(PROFILE_FIELDS.fieldNames.allergies)]: allergies,
    [formatMessage(PROFILE_FIELDS.fieldNames.medicine)]: medicine,
    [formatMessage(PROFILE_FIELDS.fieldNames.healthGoals)]: healthGoals,
  };

  return {
    avatar: profile.avatar && profile.avatar.thumbMin,
    name: get(profile, 'displayableName'),
    shortDescription,
    advancedDob,
    details: Object.keys(detailsData).reduce((acc, key) => {
      if (detailsData[key]) {
        acc.push({
          definition: key,
          description: detailsData[key],
        });
      }

      return acc;
    }, []),
    mrns: mrns.map(mrn => ({
      mrn: get(mrn, 'localUid'),
      organization: get(mrn, 'organization.name'),
    })),
    employers:
      employeeProfile &&
      employeeProfile.employeeEmployers.map(item => {
        const employeeType = get(item, 'employersEmployeeType.name', '');
        return {
          id: item.externalId,
          name: item.employer.name,
          type: employeeType,
        };
      }),
  };
};

export default getPreparedProfileData;



// WEBPACK FOOTER //
// ./src/utils/getPreparedProfileData.js